// Author lgq
// Date 2022-02-23 17:03:40

class EmSicCustomizedDiagramScd {
constructor({
        id = null,
        scdCode = '',
        scdName = '',
        scdIdImage = '',
        imageName = '',
        scdGeoJson = '',
        scdStyleJson = '',
        remark = ''}
= {}) {
    this.id = id;
    this.scdCode = scdCode;
    this.scdName = scdName;
    this.scdIdImage = scdIdImage;
    this.imageName = imageName;
    this.scdGeoJson = scdGeoJson;
    this.scdStyleJson = scdStyleJson;
    this.remark = remark;
}
}

function newEntity() {
return new EmSicCustomizedDiagramScd();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'scdCode',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.grid.scdCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'scdName',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.grid.scdName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'imageName',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.grid.imageName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'scdGeoJson',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.grid.scdGeoJson',
        sortable: true,
        form: {
        type: 'json',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'scdStyleJson',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.grid.scdStyleJson',
        sortable: true,
        form: {
        type: 'json',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    scdCodeFilter : '',
    scdNameFilter : '',
    scdIdImageFilter : '',
    imageNameFilter : '',
    scdGeoJsonFilter : '',
    scdStyleJsonFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'scdCodeFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.filter.scdCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'scdNameFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.filter.scdName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'imageNameFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.filter.imageName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'scdGeoJsonFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.filter.scdGeoJson',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'scdStyleJsonFilter',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.filter.scdStyleJson',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'scdCode',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.entity.scdCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'scdName',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.entity.scdName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'imageName',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.entity.imageName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emSicBackgroundImageSbi'
            ,correspondingField: 'sbiName'
            ,fieldsBindingByEntityModalSelected: '{"scdIdImage":"id"}'
                }
        },
        {
        key: 'scdStyleJson',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.entity.scdStyleJson',
        sortable: true,
        disabled: false,
        form: {
        type: 'json',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicCustomizedDiagramScd.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmSicCustomizedDiagramScd, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
